import {IssueLabelToken, type IssueLabelTokenProps} from '@primer/react'
import {forwardRef} from 'react'

import type {Label} from '../../api/common-contracts'
import {SanitizedHtml} from '../dom/sanitized-html'
import styles from './label-token.module.css'

interface LabelTokenProps extends Omit<IssueLabelTokenProps, 'text' | 'fillColor' | 'label' | 'ref'> {
  label: Label
}

export const LabelToken = forwardRef<HTMLAnchorElement, LabelTokenProps>(({label, ...tokenProps}, ref) => (
  <IssueLabelToken
    text={<SanitizedHtml>{label.nameHtml}</SanitizedHtml>}
    fillColor={`#${label.color}`}
    ref={ref}
    {...tokenProps}
  />
))
LabelToken.displayName = 'LabelToken'

export const LabelDecorator = ({color}: {color: string}) => {
  return (
    <div
      className={styles.LabelTokenDecorator}
      style={{
        backgroundColor: `#${color}`,
        borderColor: `#${color}`,
      }}
    />
  )
}

try{ LabelDecorator.displayName ||= 'LabelDecorator' } catch {}